import { createUseStyles } from 'react-jss'

export default createUseStyles((theme) => ({
    Button: {
        extend: theme.components.button,
        marginRight: theme.spacing.medium,
    },
}))
